const UserSvg = ({
  height = 34,
  width = 34,
  viewBox = '0 0 22 28',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M20.8333 26.5C20.8333 21.0232 16.3935 16.5833 10.9167 16.5833C5.43984 16.5833 1 21.0232 1 26.5M10.9167 12.3333C7.78705 12.3333 5.25 9.79628 5.25 6.66667C5.25 3.53705 7.78705 1 10.9167 1C14.0463 1 16.5833 3.53705 16.5833 6.66667C16.5833 9.79628 14.0463 12.3333 10.9167 12.3333Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};
export default UserSvg;
